import { render, staticRenderFns } from "./ressetLogin.vue?vue&type=template&id=0b53b582&scoped=true&"
import script from "./ressetLogin.vue?vue&type=script&lang=js&"
export * from "./ressetLogin.vue?vue&type=script&lang=js&"
import style0 from "./ressetLogin.vue?vue&type=style&index=0&id=0b53b582&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b53b582",
  null
  
)

export default component.exports